import React from "react"

export const AngleTop = () => {
  return (
    <svg width="403" height="1024" viewBox="0 0 403 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 544V0H402.748V384L0 544Z" fill="currentcolor" />
    </svg>
  )
}
